// extracted by mini-css-extract-plugin
module.exports = {"about-block":"dd31006766--about-block--XylvA","main-form":"dd31006766--main-form--a5Lo0"};